import React from "react";
import {routes} from "./routes";
import {Routes, Route} from "react-router-dom";
import {PrivateRoute} from "./private-routes";
import MainLayoutScreen from "../core/pages/MainLayoutScreen";
import { RBACRouteGuard } from "../plugins/RBACPlugin";
import { PublicRoute } from "./public-routes";
import { GuestRoute } from "./guest-route";

const Router = function(){

    return (
        <Routes>
            {routes
                .filter((route) => !route.isPrivate)
                .map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        element={
                            route.isGuestOnly ? (
                                <GuestRoute>{route.element}</GuestRoute>
                            ) : (
                                route.element
                            )
                        }
                    />
                ))
            }

            {routes
                .filter((route) => route.isPrivate)
                .map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        element={
                            <PrivateRoute>
                                <RBACRouteGuard route={route.path} allowedUserTypes={route.allowedProfileTypes} requiredPermission={route.requiredPermission}>
                                    <MainLayoutScreen>
                                        {route.element}
                                    </MainLayoutScreen>
                                </RBACRouteGuard>
                            </PrivateRoute>
                        }
                    >
                    {route.children &&
                        route.children.map((childRoute) => (
                            
                            <Route
                                key={childRoute.path}
                                index={childRoute.index}
                                path={childRoute.path}
                                element={
                                    <PrivateRoute>
                                        <RBACRouteGuard route={childRoute.path} allowedUserTypes={route.allowedProfileTypes} requiredPermission={childRoute.requiredPermission}>
                                            {childRoute.element}
                                        </RBACRouteGuard>
                                    </PrivateRoute>
                                }
                            />
                    ))}
                    </Route>
                ))
            }
            
        </Routes>
    );
    
}

export default Router